import { fromJS } from 'immutable';
import {
  UPDATE_DATA,
  SAVE_DATA,
  SAVE_ERROR_RESPONSE,
  SAVE_SUCCESS_RESPONSE,
} from './constants';
export const initialState = fromJS({
  car: {
    segmento: 'A',
    category: 'berlina',
    fuel: 'benzina',
  },
  error: null,
  response: null,
  loading: false,
});

function carCreatorReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_DATA:
      return state.set('car', fromJS(action.car));
    case SAVE_DATA:
      return state.set('loading', true);
    case SAVE_SUCCESS_RESPONSE:
      return state.set('loading', false).set('success', action.response);
    case SAVE_ERROR_RESPONSE:
      return state.set('loading', false).set('error', action.response);
    default:
      return state;
  }
}

export default carCreatorReducer;
